import { configureStore } from '@reduxjs/toolkit'
import accreditationReducer from './reducers/accreditationSlice.js';
import accreditationOverrideReducer from './reducers/accreditationOverrideSlice.js';
import appReducer from './reducers/appSlice.js';
import authReducer from './reducers/authSlice.js';
import availabilityMgrReducer from './reducers/availability/availabilityMgrSlice.js';
import awardReducer from './reducers/awardSlice.js';
import clientReducer from './reducers/clientSlice.js';
import itemReducer from './reducers/itemSlice.js';
import clientConfigReducer from './reducers/clientConfigSlice.js';
import clientContactReducer from './reducers/clientContactSlice.js';
import clientNotesReducer from './reducers/clientNotesSlice.js';
import clientOrientationReducer from './reducers/clientOrientationSlice.js';
import compartmentMgrReducer from './reducers/equipment/compartmentMgrSlice.js'
import compartmentStaffReducer from './reducers/equipment/compartmentStaffSlice.js'
import compartmentSuperReducer from './reducers/equipment/compartmentSuperSlice.js'
import contactReducer from './reducers/contactSlice.js';
import equipmentSuperReducer from './reducers/equipment/equipmentSuperSlice.js';
import equipmentMgrReducer from './reducers/equipment/equipmentMgrSlice.js';
import equipmentStaffReducer from './reducers/equipment/equipmentStaffSlice.js';
import equipmentDocumentReducer from './reducers/equipment/equipmentDocSlice.js';
import equipmentRosterMgrReducer from './reducers/equipmentRoster/equipmentRosterMgrSlice.js';
import eventClientReducer from './reducers/event/eventClientSlice.js';
import eventMgrReducer from './reducers/event/eventMgrSlice.js';
import eventDocumentReducer from './reducers/eventDocumentSlice.js';
import eventTemplateReducer from './reducers/eventTemplateSlice.js';
import eventNotesReducer from './reducers/eventNotesSlice.js';
import expenseClaimsReducer from './reducers/expenseClaimsSlice.js';
import expressionOfInterestReducer from './reducers/expressionOfInterestSlice.js';
import hoursClaimsReducer from './reducers/hoursSlice.js';
import inventoryMgrReducer from './reducers/equipment/inventoryMgrSlice.js';
import inventoryStaffReducer from './reducers/equipment/inventoryStaffSlice.js';
import inventorySuperReducer from './reducers/equipment/inventorySuperSlice.js';
import leaveMgrReducer from './reducers/leave/leaveMgrSlice.js';
import locationReducer from './reducers/locationSlice.js';
import locationOrientationReducer from './reducers/locationOrientationSlice.js';
import meetingMgrReducer from './reducers/meeting/meetingMgrSlice.js';
import meetingStaffReducer from './reducers/meeting/meetingStaffSlice.js'
import meetingAttendeeMgrReducer from './reducers/meetingAttendee/meetingAttendeeMgrSlice.js';
import meetingNoteReducer from './reducers/meetingNotesSlice.js';
import memberClientReducer from './reducers/member/memberClientSlice.js';
import memberMgrReducer from './reducers/member/memberMgrSlice.js';
import memberSuperReducer from './reducers/member/memberSuperSlice.js';
import memberAwardReducer from './reducers/memberAwardSlice.js';
import memberNoteReducer from './reducers/memberNotesSlice.js';
import memberQualifications from './reducers/memberQualificationSlice.js';
import memberAccreditationReducer from './reducers/memberAccreditationSlice.js';
import memberDocumentReducer from './reducers/memberDocumentSlice.js';
import meetingDocumentReducer from './reducers/meetingDocumentSlice.js';
import memberAuthActivityReducer from './reducers/memberAuthActivitySlice.js'
import pendingUpdateRducer from './common/reducers/pendingUpdateSlice.js'
import positionReducer from './reducers/positionSlice.js';
import qualificationReducer from './reducers/qualificationSlice.js';
import qualRequestReducer from './reducers/qualRequestSlice.js';
import refDocReducer from './reducers/refDocSlice.js';
import rosterClientReducer from './reducers/roster/rosterClientSlice.js';
import rosterMgrReducer from './reducers/roster/rosterMgrSlice.js';
import rosterUnconfirmedMgrReducer from './reducers/roster/rosterUnconfirmedMgrSlice.js';
import rosterRemovalsMgrReducer from './reducers/roster/rosterRemovalMgrSlice.js';
import shiftMgrReducer from './reducers/shift/shiftMgrSlice.js';
import shiftGroupClientReducer from './reducers/shiftGroup/shiftGroupClientSlice.js';
import shiftGroupMgrReducer from './reducers/shiftGroup/shiftGroupMgrSlice.js';
import shiftInterestReducer from './reducers/shiftInterestSlice.js'
import availabilityStaffReducer from './reducers/availability/availabilityStaffSlice.js'
import equipmentRosterStaffReducer from './reducers/equipmentRoster/equipmentRosterStaffSlice.js';
import eventStaffReducer from './reducers/event/eventStaffSlice.js';
import leaveStaffReducer from './reducers/leave/leaveStaffSlice.js';
import meetingAttendeeStaffReducer from './reducers/meetingAttendee/meetingAttendeeStaffSlice.js';
import memberStaffReducer from './reducers/member/memberStaffSlice.js';
import rosterStaffReducer from './reducers/roster/rosterStaffSlice.js';
import rosterUnconfirmedStaffReducer from './reducers/roster/rosterUnconfirmedStaffSlice.js';
import shiftStaffReducer from './reducers/shift/shiftStaffSlice.js';
import supplierReducer from './reducers/supplierSlice.js';
import shiftGroupStaffReducer from './reducers/shiftGroup/shiftGroupStaffSlice.js';
import templateReducer from './reducers/templateSlice.js';
import ticketSliceReducer from './reducers/ticketSlice.js';
import ticketNoteSliceReducer from './reducers/ticketNotesSlice.js';
import userReducer from './reducers/userSlice.js';
import visaReducer from './reducers/visaSlice.js';
import equipmentNotesReducer from './reducers/equipment/equipmentNotesSlice.js'
import workHoursReducer from './reducers/workHoursSlice.js'
import announcementReducer from './reducers/announcementSlice.js';
import shiftClientReducer from './reducers/shift/shiftClientSlice.js';
import { kioskSlice } from './reducers/kioskSlice.js';

const reducer = {};
reducer[accreditationReducer.name] = accreditationReducer.reducer;
reducer[accreditationOverrideReducer.name] = accreditationOverrideReducer.reducer;
reducer[appReducer.name] = appReducer.reducer;
reducer[authReducer.name] = authReducer.reducer;
reducer[availabilityMgrReducer.name] = availabilityMgrReducer.reducer;
reducer[awardReducer.name] = awardReducer.reducer;
reducer[announcementReducer.name] = announcementReducer.reducer;
reducer[clientConfigReducer.name] = clientConfigReducer.reducer;
reducer[clientReducer.name] = clientReducer.reducer;
reducer[clientContactReducer.name] = clientContactReducer.reducer;
reducer[clientNotesReducer.name] = clientNotesReducer.reducer;
reducer[clientOrientationReducer.name] = clientOrientationReducer.reducer;
reducer[compartmentMgrReducer.name] = compartmentMgrReducer.reducer;
reducer[compartmentStaffReducer.name] = compartmentStaffReducer.reducer;
reducer[compartmentSuperReducer.name] = compartmentSuperReducer.reducer;
reducer[contactReducer.name] = contactReducer.reducer;
reducer[equipmentSuperReducer.name] = equipmentSuperReducer.reducer;
reducer[equipmentMgrReducer.name] = equipmentMgrReducer.reducer;
reducer[equipmentStaffReducer.name] = equipmentStaffReducer.reducer;
reducer[equipmentNotesReducer.name] = equipmentNotesReducer.reducer;
reducer[equipmentDocumentReducer.name] = equipmentDocumentReducer.reducer;
reducer[equipmentRosterMgrReducer.name] = equipmentRosterMgrReducer.reducer;
reducer[eventClientReducer.name] = eventClientReducer.reducer;
reducer[eventMgrReducer.name] = eventMgrReducer.reducer;
reducer[eventDocumentReducer.name] = eventDocumentReducer.reducer;
reducer[eventNotesReducer.name] = eventNotesReducer.reducer;
reducer[eventTemplateReducer.name] = eventTemplateReducer.reducer;
reducer[expenseClaimsReducer.name] = expenseClaimsReducer.reducer;
reducer[expressionOfInterestReducer.name] = expressionOfInterestReducer.reducer;
reducer[hoursClaimsReducer.name] = hoursClaimsReducer.reducer;
reducer[inventoryMgrReducer.name] = inventoryMgrReducer.reducer;
reducer[inventoryStaffReducer.name] = inventoryStaffReducer.reducer;
reducer[inventorySuperReducer.name] = inventorySuperReducer.reducer;
reducer[itemReducer.name] = itemReducer.reducer;
reducer[kioskSlice.name] = kioskSlice.reducer;
reducer[locationReducer.name] = locationReducer.reducer;
reducer[locationOrientationReducer.name] = locationOrientationReducer.reducer;
reducer[meetingMgrReducer.name] = meetingMgrReducer.reducer;
reducer[meetingStaffReducer.name] = meetingStaffReducer.reducer;
reducer[meetingNoteReducer.name] = meetingNoteReducer.reducer;
reducer[meetingDocumentReducer.name] = meetingDocumentReducer.reducer;
reducer[memberClientReducer.name] = memberClientReducer.reducer;
reducer[memberMgrReducer.name] = memberMgrReducer.reducer;
reducer[memberSuperReducer.name] = memberSuperReducer.reducer;
reducer[memberAwardReducer.name] = memberAwardReducer.reducer;
reducer[memberNoteReducer.name] = memberNoteReducer.reducer;
reducer[memberQualifications.name] = memberQualifications.reducer;
reducer[memberAuthActivityReducer.name] = memberAuthActivityReducer.reducer;
reducer[meetingAttendeeMgrReducer.name] = meetingAttendeeMgrReducer.reducer;
reducer[leaveMgrReducer.name] = leaveMgrReducer.reducer;
reducer[memberAccreditationReducer.name] = memberAccreditationReducer.reducer;
reducer[memberDocumentReducer.name] = memberDocumentReducer.reducer;
reducer[pendingUpdateRducer.name] = pendingUpdateRducer.reducer;
reducer[positionReducer.name] = positionReducer.reducer;
reducer[qualificationReducer.name] = qualificationReducer.reducer;
reducer[qualRequestReducer.name] = qualRequestReducer.reducer;
reducer[refDocReducer.name] = refDocReducer.reducer;
reducer[rosterClientReducer.name] = rosterClientReducer.reducer;
reducer[rosterMgrReducer.name] = rosterMgrReducer.reducer;
reducer[rosterUnconfirmedMgrReducer.name] = rosterUnconfirmedMgrReducer.reducer;
reducer[rosterRemovalsMgrReducer.name] = rosterRemovalsMgrReducer.reducer;
reducer[shiftClientReducer.name] = shiftClientReducer.reducer;
reducer[shiftMgrReducer.name] = shiftMgrReducer.reducer;
reducer[shiftGroupClientReducer.name] = shiftGroupClientReducer.reducer;
reducer[shiftGroupMgrReducer.name] = shiftGroupMgrReducer.reducer;
reducer[shiftInterestReducer.name] = shiftInterestReducer.reducer;
reducer[availabilityStaffReducer.name] = availabilityStaffReducer.reducer;
reducer[equipmentRosterStaffReducer.name] = equipmentRosterStaffReducer.reducer;
reducer[eventStaffReducer.name] = eventStaffReducer.reducer;
reducer[leaveStaffReducer.name] = leaveStaffReducer.reducer;
reducer[meetingAttendeeStaffReducer.name] = meetingAttendeeStaffReducer.reducer;
reducer[memberStaffReducer.name] = memberStaffReducer.reducer;
reducer[rosterStaffReducer.name] = rosterStaffReducer.reducer;
reducer[rosterUnconfirmedStaffReducer.name] = rosterUnconfirmedStaffReducer.reducer;
reducer[shiftStaffReducer.name] = shiftStaffReducer.reducer;
reducer[shiftGroupStaffReducer.name] = shiftGroupStaffReducer.reducer;
reducer[supplierReducer.name] = supplierReducer.reducer;
reducer[templateReducer.name] = templateReducer.reducer;
reducer[ticketSliceReducer.name] = ticketSliceReducer.reducer;
reducer[ticketNoteSliceReducer.name] = ticketNoteSliceReducer.reducer;
reducer[userReducer.name] = userReducer.reducer;
reducer[visaReducer.name] = visaReducer.reducer;
reducer[workHoursReducer.name] = workHoursReducer.reducer;

export const store = configureStore({
  reducer
});